var React = require('react');

function Other (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"clip-careers-estimate-other"},React.createElement("rect",{"width":"83","height":"83"}))),React.createElement("g",{"id":"careers-estimate-other","clipPath":"url(#clip-careers-estimate-other)","key":1},React.createElement("text",{"id":"_","data-name":"?","transform":"translate(23 65)","fill":"#a5a4a6","fontSize":"64","fontFamily":"Montserrat-Bold, Montserrat","fontWeight":"700"},React.createElement("tspan",{"x":"0","y":"0"},"?")))]);
}

Other.defaultProps = {"width":"83","height":"83","viewBox":"0 0 83 83"};

module.exports = Other;

Other.default = Other;
